<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'USERS.FILTER.TITLE' | translate }}
  </span>
</mat-toolbar>

<form class="filter-content" [formGroup]="filtersForm" fusePerfectScrollbar>
  <input
    class="mt-4 input-legacy"
    formControlName="name"
    name="name"
    placeholder="{{ 'USERS.FILTER.NAME' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <input
    class="mt-16 input-legacy"
    formControlName="email"
    name="email"
    placeholder="{{ 'USERS.FILTER.EMAIL' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <location-legacy class="mt-16" formControlName="locationId"></location-legacy>

  <mat-divider class="mt-16"></mat-divider>

  <user-group-legacy class="mt-16" formControlName="groupId"></user-group-legacy>

  <mat-divider class="mt-16"></mat-divider>

  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-label for="type">{{ 'USERS.FILTER.TYPE' | translate }}</mat-label>
    <mat-select formControlName="type">
      <mat-option value="">{{ 'USERS.USER_TYPE.ALL' | translate }}</mat-option>
      <mat-option value="all">{{ 'USERS.USER_TYPE.ADMIN' | translate }}</mat-option>
      <mat-option value="admin">{{ 'USERS.USER_TYPE.MANAGER' | translate }}</mat-option>
      <mat-option value="requester">{{ 'USERS.USER_TYPE.REQUESTER' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>

  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-label for="type">{{ 'USERS.FILTER.SITUATION.TITLE' | translate }}</mat-label>
    <mat-select formControlName="archived">
      <mat-option [value]="false">{{ 'USERS.FILTER.SITUATION.ACTIVE' | translate }}</mat-option>
      <mat-option [value]="true">{{ 'USERS.FILTER.SITUATION.INACTIVE' | translate }}</mat-option>
      <mat-option [value]="''">{{ 'USERS.STATUS.ALL' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>
</form>
